type WindowWithEvents = Pick<Window, 'addEventListener'>

export interface BrowserNavigationEvents {
  onHistoryChanged: (callback: () => void) => void
  onPageRestoredFromCache: (callback: () => void) => void
}

export function createBrowserNavigationEvents(
  getWindow: () => WindowWithEvents | undefined = () => (typeof window === 'undefined' ? undefined : window),
): BrowserNavigationEvents {
  function onHistoryChanged(callback: () => void) {
    getWindow()?.addEventListener('popstate', () => callback())
  }

  function onPageRestoredFromCache(callback: () => void) {
    getWindow()?.addEventListener('pageshow', (event) => {
      if (event.persisted)
        callback()
    })
  }

  return { onHistoryChanged, onPageRestoredFromCache }
}

export const browserNavigationEvents = createBrowserNavigationEvents()
